import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["typeRadio"]
  static values = { url: String, cancelUrl: String, fieldKey: String, errorMessage: String }

  async save(event) {
    event.preventDefault()

    const selectedType = this.typeRadioTargets.find((r) => r.checked)?.value
    const csrfToken = document.querySelector("[name='csrf-token']")?.content

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          Accept: "text/vnd.turbo-stream.html",
        },
        body: JSON.stringify({
          field_key: this.fieldKeyValue,
          input_type: selectedType,
        }),
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      } else {
        throw new Error("Update failed")
      }
    } catch (error) {
      console.error("Error updating notes input type:", error)
      alert(this.errorMessageValue || "Error saving. Please try again.")
    }
  }

  cancel(event) {
    event.preventDefault()

    const frame = document.getElementById(`core_field_${this.fieldKeyValue}`)
    if (frame && this.cancelUrlValue) {
      frame.src = this.cancelUrlValue
      frame.reload()
    }
  }
}
